import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../lib/api';
import { useAuth } from './useAuth';

export interface TelegramNotificationsState {
  enabled: boolean;
  linked: boolean;
  linkUrl: string | null;
}

export const TELEGRAM_NOTIFICATIONS_QUERY_KEY = ['notifications', 'telegram'] as const;

export function useTelegramNotifications() {
  const { data: user } = useAuth();
  return useQuery({
    queryKey: TELEGRAM_NOTIFICATIONS_QUERY_KEY,
    queryFn: () => apiGet<TelegramNotificationsState>('/api/notifications/telegram'),
    enabled: !!user,
    // Клієнт підключає бота в Telegram і повертається на вкладку — стан має
    // оновитись без перезавантаження (глобально refetchOnWindowFocus вимкнено).
    staleTime: 0,
    refetchOnWindowFocus: true,
  });
}
